var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.selectedOptions),function(item){return _c('span',{key:item,staticClass:"printable-multiselect item pr-2 d-inline-flex"},[_c('span',{staticClass:"fa fa-check mr-2 mt-1"}),_c('span',[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }